import Layout from '@/layout'

export default [
  {
    path: '/college',
    name: 'College',
    component: Layout,
    redirect: '/college/index',
    children: [
      {
        path: 'index',
        name: 'CollegeIndex',
        component: () => import(/*webpackChunkName:'CollegeIndex'*/ '@/views/college'),
        meta: { title: '学堂', homePage: true },
      },
    ],
  },
  {
    path: '/college/:organizationId',
    name: 'CollegeDetail',
    component: () =>
      import(/*webpackChunkName:'CollegeDetail'*/ '@/views/college/CollegeDetail.vue'),
    meta: { title: '学堂详情' },
  },
  {
    path: '/college/class/:classId',
    name: 'ClassDetail',
    component: () => import(/*webpackChunkName:'ClassDetail'*/ '@/views/college/ClassDetail'),
    meta: { title: '班级详情' },
  },
  {
    path: '/college/teacher/:id',
    name: 'TeacherDetail',
    component: () =>
      import(/*webpackChunkName:'TeacherDetail'*/ '@/views/college/TeacherDetail.vue'),
    meta: { title: '教师详情' },
  },
]
